<template>
  <Modal
    :modal-active="isModalOpen"
    :model="props.model?.modal"
    :title="t('supportRequest.title')"
    @close="handleClose(true)"
    :close-disabled="isSubmitting"
    :key="componentKey"
  >
    <div class="modal-content">
      <SupportForm
        :model="props.model"
        :key="componentKey"
        @close="handleClose"
        @submit-start="disableClose"
        @submit-end="enableClose"
        ref="supportFormRef"
      >
      </SupportForm>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '../Modal.vue'
import SupportForm from './SupportForm.vue'
import { t } from '../../composables/Translation'
import { updateComponentKey } from '../../composables/ComponentKey'
import type { SupportRequest } from '../../types/configuration/SupportRequest'
import { ref, watch } from 'vue'
import { useAppStore } from '../../stores/appStore'

const emit = defineEmits<{ (e: 'close'): void }>()
const isSubmitting = ref<boolean>(false)
const appStore = useAppStore()

const supportFormRef = ref<{ resetFormData: () => void } | null>(null)

function handleClose(showSupportRequestButton = false) {
  //ensures that the button will be displayed for all login forms when the user closes the modal without sending it
  if (showSupportRequestButton) {
    appStore.supportRequestButtonVisible = true
  }
  emit('close')
}

function disableClose() {
  isSubmitting.value = true
}

function enableClose() {
  isSubmitting.value = false
}

const props = defineProps<{
  model: SupportRequest | undefined
  isModalOpen: boolean
}>()
let componentKey = updateComponentKey(props)

watch(
  () => props.isModalOpen,
  newIsModalOpen => {
    if (newIsModalOpen) {
      supportFormRef.value?.resetFormData()
    }
  },
  { immediate: true }
)
</script>
<style scoped lang="scss"></style>
